import {
    Book,
    GraduationCap,
    LayoutDashboard,
    LucideIcon,
    Mail,
    UserCog,
    Users,
} from "lucide-react";

export type PublicLinksTranslation =
    | "links.home"
    | "links.courses"
    | "links.team"
    | "links.aboutUs"
    | "links.backTo"
    | "links.contactUs"
    | "links.admins"
    | "links.instructors"
    | "links.students"
    | "links.dashboard"
    | "links.certificateRequests"
    | "links.reports"
    | "links.rolesPermissions"
    | "links.users"
    | "links.emailTemplates";

export type PrivateLinksTranslation =
    | "links.home"
    | "links.courses"
    | "links.certificateRequests"
    | "links.team"
    | "links.aboutUs"
    | "links.backTo"
    | "links.contactUs"
    | "links.admins"
    | "links.instructors"
    | "links.students"
    | "links.dashboard"
    | "links.reports"
    | "links.rolesPermissions"
    | "links.users"
    | "links.emailTemplates";
export type NavbarLink = {
    name: PublicLinksTranslation | PrivateLinksTranslation;
    url: string;
    icon?: LucideIcon;
    role?: "super-admin" | "admin" | "instructor" | "student";
    permission?: string;
    /** Only show this link when the given tenant feature flag is on. */
    feature?: "liveCourses";
};

export const publicLinks: NavbarLink[] = [
    {
        name: "links.home",
        url: "/",
        role: "student",
    },
    {
        name: "links.aboutUs",
        url: "/about",
        role: "student",
    },
    {
        name: "links.courses",
        url: "/courses",
        role: "student",
    },

    {
        name: "links.contactUs",
        url: "/contact",
        role: "student",
    },
];

export const adminLinks: NavbarLink[] = [
    {
        name: "links.dashboard",
        url: "/admin/dashboard",
        icon: LayoutDashboard,
        role: "instructor",
        permission: "view dashboard",
    },
    {
        name: "links.courses",
        url: "/admin/courses",
        icon: Book,
        role: "instructor",
        permission: "read courses",
    },
    {
        name: "links.certificateRequests",
        url: "/admin/requests",
        icon: GraduationCap,
        role: "admin",
        permission: "read certificate requests",
    },
    {
        name: "links.instructors",
        url: "/admin/instructors",
        icon: Users,
        role: "admin",
        permission: "read instructors",
    },
    {
        name: "links.students",
        url: "/admin/students",
        icon: GraduationCap,
        role: "admin",
        permission: "read students",
    },
    {
        name: "links.admins",
        url: "/admin/admins",
        icon: UserCog,
        role: "super-admin",
        permission: "read admins",
    },
    {
        name: "links.reports",
        url: "/admin/reports",
        icon: UserCog,
        role: "admin",
        permission: "read reports",
    },
    {
        // Not feature-gated: admin-authored templates are used by every tenant (the
        // controller hides the live-course lifecycle ones where they don't apply).
        name: "links.emailTemplates",
        url: "/admin/email-templates",
        icon: Mail,
        role: "admin",
        permission: "read email templates",
    },
    {
        name: "links.rolesPermissions",
        url: "/admin/roles-permissions",
        icon: UserCog,
        role: "admin",
        permission: "read roles",
    },
    {
        name: "links.users",
        url: "/admin/users",
        icon: Users,
        role: "admin",
        permission: "read users",
    },
];
